export default "__VITE_ASSET__B3zQvHZH__"